/**
 * Manage payments data
 */
import Ajax from '@/lib/ajax_wrapper'

function invoicesPath(companyId) {
  return `/companies/${companyId}/payments/invoices`
}

/**
 * List all customer invoices
 *
 * @returns {promise}
 */
export function readCustomerInvoicesData(companyId, limit) {
  return Ajax.request({
    url: `${invoicesPath(companyId)}?limit=${limit}`,
    method: 'GET'
  })
}

/**
 * List all upcoming customer invoices
 *
 * @returns {promise}
 */
export function readCustomerUpcomingInvoicesData(companyId, limit) {
  return Ajax.request({
    url: `${invoicesPath(companyId)}/upcoming`,
    method: 'GET'
  })
}

/**
 * List customer invoice
 *
 * @returns {promise}
 */
export function readCustomerInvoiceData(companyId, invoiceId) {
  return Ajax.request({
    url: `${invoicesPath(companyId)}/${invoiceId}`,
    method: 'GET'
  })
}

/**
 * Pay an invoice using specififed payment method
 *
 * @returns {promise}
 */
export function createCustomerInvoicePaymentData(companyId, invoiceId, paymentMethodId) {
  return Ajax.request({
    url: `${invoicesPath(companyId)}/${invoiceId}/pay`,
    method: 'POST',
    data: paymentMethodId
  })
}
